import { render, staticRenderFns } from "./role-permissions.vue?vue&type=template&id=573991ee&scoped=true"
import script from "./role-permissions.vue?vue&type=script&lang=js"
export * from "./role-permissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573991ee",
  null
  
)

export default component.exports